import { NO, NOT_AVAILABLE, YES } from '@constants/common';
import { withTooltip } from '@hooks/common/useDynamicColumns/utils/withTooltip';
import { JobLeadEntity } from '@hooks/types';
import { capitalize } from '@utils/formatInitials';
import { get } from 'lodash-es';

import LockOpenIcon from '@mui/icons-material/LockOpen';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box, Button, Tooltip, Typography } from '@mui/material';

export const createJobsColumns = () => [
  {
    field: 'unlock_lead',
    headerName: '',
    headerClassName: 'super-bold--header',
    width: 110,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({
      row,
    }: {
      row: JobLeadEntity & { purchased?: boolean; is_purchased?: boolean; _isPreviewRow?: boolean };
    }) => {
      const isPurchased = row.purchased === true || row.is_purchased === true;
      const isPreviewRow = row._isPreviewRow === true;

      if (isPurchased) {
        return (
          <Box display="flex" alignItems="center" gap={0.5}>
            <LockOpenIcon sx={{ color: '#00d4aa', fontSize: 16 }} />
            <Typography variant="caption" sx={{ color: '#00d4aa', fontWeight: 600, fontSize: '0.7rem' }}>
              Unlocked
            </Typography>
          </Box>
        );
      }

      if (isPreviewRow) {
        return (
          <Tooltip title="Free preview row - purchase to save to your leads">
            <Typography variant="caption" sx={{ color: '#90caf9', fontWeight: 500, fontSize: '0.7rem' }}>
              Preview
            </Typography>
          </Tooltip>
        );
      }

      return (
        <Tooltip title="Purchase lead for 1 credit to reveal contact info">
          <Button
            size="small"
            variant="contained"
            onClick={e => e.stopPropagation()}
            sx={{
              backgroundColor: 'rgba(0, 212, 170, 0.15)',
              color: '#00d4aa',
              fontSize: '0.65rem',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 'auto',
              px: 1,
              py: 0.25,
              borderRadius: '4px',
              '&:hover': { backgroundColor: 'rgba(0, 212, 170, 0.25)' },
            }}
            startIcon={<ShoppingCartIcon sx={{ fontSize: '12px !important' }} />}
          >
            1 credit
          </Button>
        </Tooltip>
      );
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    headerClassName: 'super-bold--header',
    width: 300,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(get(row, 'data.email', NOT_AVAILABLE)),
  },
  {
    field: 'contact_phone',
    headerName: 'Contact phone',
    headerClassName: 'super-bold--header',
    width: 150,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(get(row, 'data.phone', NOT_AVAILABLE)),
  },
  {
    field: 'company_name',
    headerName: 'Company Name',
    headerClassName: 'super-bold--header',
    width: 275,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) =>
      withTooltip(capitalize(get(row, 'data.company_name', NOT_AVAILABLE))),
  },
  {
    field: 'company_location',
    headerName: 'Company Location',
    headerClassName: 'super-bold--header',
    width: 400,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) =>
      withTooltip(capitalize(get(row, 'data.company_location', NOT_AVAILABLE))),
  },
  {
    field: 'job_type',
    headerName: 'Job type',
    headerClassName: 'super-bold--header',
    width: 100,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(get(row, 'data.job_type', NOT_AVAILABLE)),
  },
  {
    field: 'job_title',
    headerName: 'Job title',
    headerClassName: 'super-bold--header',
    width: 400,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(capitalize(get(row, 'data.job_title', NOT_AVAILABLE))),
  },
  {
    field: 'job_shift',
    headerName: 'Job shift',
    headerClassName: 'super-bold--header',
    width: 200,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(get(row, 'data.job_shift', NOT_AVAILABLE)),
  },
  {
    field: 'vacancy_expired',
    headerName: 'Vacant',
    headerClassName: 'super-bold--header',
    width: 100,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) =>
      withTooltip(capitalize(get(row, 'data.vacancy_expired') ? NO : YES)),
  },
  {
    field: 'rating',
    headerName: 'Rating',
    headerClassName: 'super-bold--header',
    width: 100,
    hideable: false,
    sortable: false,
    resizable: false,
    renderCell: ({ row }: { row: JobLeadEntity }) => withTooltip(get(row, 'data.rating', NOT_AVAILABLE)),
  },
];
